import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_FETCH } from '../../services';
import { ENDPOINTS } from '../../constants/endpoints';

export interface Skills {
    lookupValueCd: string, 
    lookupValueDesc: string
}

interface SkillsState {
    skills: Skills[];  // ✅ Changed from [] | null to Skills[]
    loading: boolean;
    error: string | null;
}

const initialState: SkillsState = {
    skills: [],
    loading: false,
    error: null,
};


// ========================================
// ASYNC THUNKS
// ========================================
/**
 * Fetch skill list by passing the site code as a query parameter
 * Uses: ENDPOINTS.GET_SKILLS + siteID
 */
export const fetchSkills = createAsyncThunk(
    'Skills/fetchSkills',
    async (siteCd: string, { rejectWithValue }) => {
        try {
            const response = await API_FETCH(`${ENDPOINTS.GET_SKILLS}/${siteCd}`);
            console.log('✅ Skills API Response:', response); // Add logging
            return response;
        } catch (error: any) {
            console.error('❌ Skills API Error:', error); // Add logging
            return rejectWithValue(error?.message || 'Failed to fetch skills');
        }
    }
);


// ========================================
// SLICE
// ========================================
const skillsSlice = createSlice({
    name: 'skills',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSkills.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSkills.fulfilled, (state, action) => {
                state.loading = false;
                state.skills = action.payload;
                console.log('✅ Skills stored in Redux:', state.skills); // Add logging
            })
            .addCase(fetchSkills.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                console.error('❌ Skills fetch rejected:', action.payload); // Add logging
            });
    },
});

export const { clearError } = skillsSlice.actions;
export default skillsSlice.reducer;